
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "donut",
  "use": "donut-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"donut\"><path d=\"M24 2C11.85 2 2 11.85 2 24s9.85 22 22 22 22-9.85 22-22S36.15 2 24 2zm0 10c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12z\" /></symbol>"
});
    sprite.add(symbol);

    export default class DonutSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="donut" {...this.props} />;
      }
    }
  